var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popupComponent":_vm.popupComponent,"sort":"site_url","title":"Site Ownership","icon":"mdi-lock-reset","stateendpoint":"siteOwnership.siteOwnerships","actions":_vm.actions,"show-default-action-buttons":false,"action-buttons":_vm.actionButtons,"show-add-button":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }